/* eslint-disable react/prop-types */
import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { capitalize } from 'relevant-shared/misc/misc';
import ExternalSystemEdit from '../components/ExternalSystemEdit';
import FieldArray from '../components/FieldArray';
import TextField from '../components/TextField';
import Select from '../components/Select';
import classes from '../api/classes';
import ExpandSelector from '../components/ExpandSelector';
import Disabler from '../components/Disabler';

const { PriceGranularityRange } = classes;

const TYPES = ['low', 'medium', 'high', 'auto', 'dense', 'custom'];

const renderRange = (field) => (
	<Grid container spacing={3}>
		<Grid item xs={6}>
			<TextField
				{...field('increment')}
				label="Increment"
				required
				float
				fullWidth
				margin="normal"
			/>
		</Grid>
		<Grid item xs={6}>
			<TextField
				{...field('max')}
				label="Max"
				required
				float
				fullWidth
				margin="normal"
			/>
		</Grid>
	</Grid>
);

function Renderer({ field, form, model, renderParams }) {
	const {
		title = 'Price granularity',
	} = renderParams || {};
	return (
		<Card>
			<CardHeader title={title} />
			<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Select
							fullWidth
							label="Price granularity"
							{...field('priceGranularity')}
							items={TYPES.map((value) => ({ label: capitalize(value), value }))}
						/>
					</Grid>
					<Grid item xs={12}>
						<Disabler disabled={model.priceGranularity !== 'custom'}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<TextField
										{...field('customPriceGranularityPrecision')}
										label="Custom price granularity precision"
										required
										integer
										fullWidth
										margin="normal"
									/>
								</Grid>
								<Grid item xs={12}>
									<ExpandSelector
										selected={model.customPriceGranularityRanges}
										title="Custom price granularity ranges"
										form={form}
									>
										<FieldArray
											model={model}
											field={field}
											name="customPriceGranularityRanges"
											update={() => form.update()}
											createNew={() => new PriceGranularityRange()}
											render={renderRange}
										/>
									</ExpandSelector>
								</Grid>
							</Grid>
						</Disabler>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
}

ExternalSystemEdit.registerCustomRenderer('PriceGranularitySettings', Renderer);
